import { LabCustomerUserBusiness as _LabCustomerUserBusiness } from '@team-milva/lab-models/user'
import type { ILabCustomerUserBusiness } from '@team-milva/lab-models/user'
import type { DeepPartial } from '@/types/types'

export interface ITermsOfUseAcceptance {
  version: string
  acceptedAt: number
}

// App-local field until MIL-136 (Terms of Use, authored/versioned in lab-management) ships —
// then this should move into ILabCustomerUserBusiness in @team-milva/lab-models.
export class LabCustomerUserBusiness extends _LabCustomerUserBusiness {
  termsAccepted: ITermsOfUseAcceptance | null

  constructor(
    params: DeepPartial<ILabCustomerUserBusiness> & {
      termsAccepted?: ITermsOfUseAcceptance | null
    } = {}
  ) {
    super(params)
    this.termsAccepted = params.termsAccepted ?? null
  }
}
